import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

import { IconVariant } from '../constants/icons'
import { capitalize } from '../utils/languageUtils'

const useStyles = makeStyles(
  theme => ({
    circle: {},
    path: {},
    circlePrimary: {
      fill: theme.colors.success,
    },
    pathPrimary: {
      fill: theme.colors.profileText,
    },
    circleSecondary: {
      fill: theme.colors.profileText,
    },
    pathSecondary: {
      fill: theme.colors.success,
    },
    circleDisabled: {
      fill: theme.colors.profileText,
    },
    pathDisabled: {
      fill: theme.colors.selectedOption,
    },
    circleWarning: {
      fill: theme.colors.profileText,
    },
    pathWarning: {
      fill: theme.colors.planWarning,
    },
    circleInactive: {
      fill: theme.colors.inactiveBackground,
    },
    pathInactive: {
      fill: theme.colors.profileText,
    },
    circleSuspensed: {
      fill: theme.colors.actionNeededBackground,
    },
    pathSuspensed: {
      fill: theme.colors.planSuspensed,
    },
    circlePaused: {
      fill: theme.colors.important,
    },
    pathPaused: {
      fill: theme.colors.profileText,
    },
  }),
  { name: 'Wellness' },
)

export interface WellnessProps extends SvgIconProps {
  readonly variant?: IconVariant
}

const Wellness = forwardRef<SVGSVGElement, WellnessProps>(function Wellness(
  { classes: classesProp, variant = IconVariant.PRIMARY, ...rest },
  ref,
) {
  const classes = useStyles({ classes: classesProp })

  const variantClass = capitalize(variant)

  return (
    <SvgIcon ref={ref} {...rest}>
      <circle
        className={classNames(classes.circle, classes[`circle${variantClass}`])}
        cx="12"
        cy="12"
        r="12"
      />
      <path
        className={classNames(classes.path, classes[`path${variantClass}`])}
        d="M11.41 6.287a3.657 3.657 0 015.332 0c1.472 1.54 1.472 4.034 0 5.572L11 17.86l-5.742-6c-1.472-1.54-1.472-4.034 0-5.573a3.657 3.657 0 015.332 0l.41.429zm.321 2.913H10.27v1.369H8.9v1.462h1.357V13.4h1.474v-1.37H13.1V10.57h-1.369V9.2z"
        transform="translate(1, 1)"
      />
    </SvgIcon>
  )
})

export default Wellness
